import React from 'react';

const StatsCard = ({ title, value, subtitle, icon, color = 'blue' }) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    orange: 'from-orange-500 to-orange-600',
    purple: 'from-purple-500 to-purple-600',
    red: 'from-red-500 to-red-600'
  };

  // Safety check for NaN values and format display
  const safeValue = (typeof value === 'number' && !isNaN(value)) ? value : 0;
  const displayValue = Number.isInteger(safeValue) ? safeValue : safeValue.toFixed(1);

  return (
    <div className={`bg-gradient-to-br ${colorClasses[color]} rounded-xl p-4 text-white shadow-lg transform hover:scale-105 transition-transform duration-200`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-blue-100 text-xs font-medium mb-1">{title}</p>
          <p className="text-2xl font-bold">{displayValue}</p>
          <p className="text-blue-100 text-xs mt-1">{subtitle}</p>
        </div>
        <div className="text-3xl opacity-80">
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
